import React from 'react';

export default function FilingScheduleTooltip(props) {
	// console.log('FilingScheduleTooltip', props);
	return (
		<div className="px-3 py-1 text-sm">
			<div className="my-2 underline">Tax Returns</div>
			<div className="my-2">General Excise/Use Tax Return (G-45)</div>
			<div className="my-2">
				Periodic Transient Accommodations Tax Return (TA-1)
			</div>

			{/*<div>Hawaii - Maui - Annual - Online</div>
			<div>General Excise/Use Annual Return & Reconciliation (G-49)</div>
			<div>General Excise/Use Annual Return & Reconciliation (G-49)</div>*/}
		</div>
	);
}
